module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '新建BU',
      "pop": true
    }
  }, [_c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: ('back-createBu'),
      expression: "'back-createBu'"
    }],
    staticClass: "main"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU名称")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.bu_name),
      expression: "sub.bu_name"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请输入BU名称"
    },
    model: {
      value: (_vm.sub.bu_name),
      callback: function($$v) {
        _vm.$set(_vm.sub, "bu_name", $$v)
      },
      expression: "sub.bu_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU合伙人")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.leader_id),
      expression: "sub.leader_id"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sub.leader_id),
      callback: function($$v) {
        _vm.$set(_vm.sub, "leader_id", $$v)
      },
      expression: "sub.leader_id"
    }
  }, _vm._l((_vm.person_list), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.real_name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item area"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU职责")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('BU职责描述'),
      expression: "'BU职责描述'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.describe),
      expression: "sub.describe"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub.describe),
      expression: "sub.describe"
    }],
    attrs: {
      "rule": "reason describe_limit",
      "placeholder": "请描述BU职责"
    },
    domProps: {
      "value": (_vm.sub.describe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sub, "describe", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                    经营范围\n                    "), _c('el-checkbox', {
    on: {
      "change": _vm.manageAll
    },
    model: {
      value: (_vm.check_manage),
      callback: function($$v) {
        _vm.check_manage = $$v
      },
      expression: "check_manage"
    }
  })], 1), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.manage_strIds),
      expression: "manage_strIds"
    }],
    on: {
      "change": _vm.manageCheck
    },
    model: {
      value: (_vm.sub.manage_ids),
      callback: function($$v) {
        _vm.$set(_vm.sub, "manage_ids", $$v)
      },
      expression: "sub.manage_ids"
    }
  }, _vm._l((_vm.tpl_list), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.tpl_name))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                    发布范围\n                    "), _c('el-checkbox', {
    on: {
      "change": _vm.releaseAll
    },
    model: {
      value: (_vm.check_release),
      callback: function($$v) {
        _vm.check_release = $$v
      },
      expression: "check_release"
    }
  })], 1), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.release_strIds),
      expression: "release_strIds"
    }],
    on: {
      "change": _vm.releaseCheck
    },
    model: {
      value: (_vm.sub.release_ids),
      callback: function($$v) {
        _vm.$set(_vm.sub, "release_ids", $$v)
      },
      expression: "sub.release_ids"
    }
  }, _vm._l((_vm.tpl_list), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.tpl_name))])
  }))], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.user_strIds),
      expression: "user_strIds"
    }],
    staticClass: "right"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("BU成员选择")]), _vm._v(" "), _c('member', {
    attrs: {
      "leaderId": _vm.sub.leader_id,
      "list": _vm.person_list,
      "cancel": _vm.cancel_flag
    },
    on: {
      "change": _vm.getMemberIds,
      "cancel": function($event) {
        _vm.cancel_flag = false
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("创建")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-01e70dd3!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/person/page-add-bu.vue
// module id = 681
// module chunks = 1